import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { X, ArrowLeft, Check } from 'lucide-react'
import Button from '../components/common/Button'

function PayPalCancel() {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <>
      <Helmet>
        <title>Payment Cancelled - HireFlow</title>
        <meta name="description" content="Your payment was cancelled." />
      </Helmet>

      <section className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-neutral-50 py-20">
        <div className="container-custom max-w-3xl">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            transition={{ duration: 0.6 }}
            className="card p-12 text-center"
          >
            {/* Cancel Icon */}
            <div className="w-20 h-20 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <X className="w-10 h-10 text-neutral-600" />
            </div>

            {/* Main Heading */}
            <h1 className="heading-lg mb-4">Payment Cancelled</h1>
            <p className="text-xl text-neutral-600 mb-8">
              No worries! Your payment was cancelled and you were not charged.
            </p>

            {/* Free Tier Features */}
            <div className="bg-primary-50 rounded-xl p-6 mb-8 text-left">
              <h3 className="font-semibold text-neutral-900 mb-4">You can still enjoy HireFlow with:</h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" />
                  <span className="text-neutral-700">
                    3 LinkedIn → Resume conversions per month
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" />
                  <span className="text-neutral-700">
                    3 Job-Matched CVs per month
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" />
                  <span className="text-neutral-700">
                    1 LinkedIn Enhancement per month
                  </span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-primary-600 flex-shrink-0 mt-0.5" />
                  <span className="text-neutral-700">
                    Basic ATS-Optimized PDF export
                  </span>
                </li>
              </ul>
            </div>

            {/* Upgrade Info */}
            <p className="text-neutral-600 mb-8">
              Want to unlock unlimited features? Return to pricing anytime!
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="primary"
                size="lg"
                href="/pricing"
              >
                View Pricing Again
                <ArrowLeft className="w-5 h-5 ml-2" />
              </Button>
              <Button
                variant="secondary"
                size="lg"
                href="/"
              >
                Continue with Free Tier
              </Button>
            </div>

            {/* Help Text */}
            <p className="text-sm text-neutral-500 mt-8">
              Need help? <a href="/contact" className="text-primary-600 hover:text-primary-700 font-medium">Contact our support team</a>
            </p>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default PayPalCancel
